// @flow
import * as React from 'react';

import { CornerDownRight } from 'lucide-react';
import { useDispatch } from 'react-redux';

import {
  updateProductAndGetCartOrNotify,
  type AcmeCreate as AcmeProductCreate,
  type DecoratedProduct,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import type { GandiFormSelectOption } from 'src/Domain/types';

import { ListRow } from '../../ListRow';
import { useBestCatalogPrice } from '../modules/catalog';

import { AcmeProductItem } from './AcmeProductItem';
import { DurationRow } from './components/Rows';

type Props = { product: AcmeProductCreate & DecoratedProduct };

export function AcmeCreate({ product }: Props): React.MixedElement {
  const dispatch = useDispatch();
  const { __ } = useTranslator();
  const { priceCrossedOut, total } = useBestCatalogPrice(product.id);

  const handleDurationChange = (
    selectedOption: GandiFormSelectOption<number>,
  ) => {
    const newPayload = { ...product.payload, duration: selectedOption.value };
    dispatch(updateProductAndGetCartOrNotify(__, product.id, newPayload));
  };

  const payload = product.payload;
  const duration = payload.duration || 1;
  const durations = [1, 2, 3];
  if (!durations.includes(duration)) durations.push(duration);

  const footer = (
    <DurationRow
      value={duration}
      values={durations}
      disabledOption={!!product.isWorking}
      onChange={handleDurationChange}
      priceCrossedOut={priceCrossedOut}
      productId={product.id}
      total={total}
    />
  );

  return (
    <AcmeProductItem
      product={product}
      domains={payload.domains}
      footer={footer}
    >
      {payload.validation_type ? (
        <ListRow
          icon={<CornerDownRight size={16} />}
          title={
            payload.validation_type === 'dv'
              ? __('Domain Validation (Standard)')
              : payload.validation_type === 'ov'
                ? __('Organization Validation (Pro)')
                : payload.validation_type.toUpperCase()
          }
        />
      ) : null}
    </AcmeProductItem>
  );
}
